import React from "react";
import { Mutation, compose } from "react-apollo";
import gql from "graphql-tag";
import Button from "@material-ui/core/Button";
import { withNotification } from "../../../notification/context";

const MUTATION = gql`
  mutation($id: ID!) {
    selectDefaultLayer(id: $id) {
      id
      name
      description
      isDefault
    }
  }
`;

const SelectAsDefaultButton = ({ id, isDefault, openNotification, query }) => {
  return (
    <Mutation mutation={MUTATION}>
      {(mutation, { loading }) => {
        const handleClick = () => {
          mutation({
            variables: { id },
            refetchQueries: [
              {
                query
              }
            ]
          })
            .then(() => {
              openNotification("Capa actualizada con éxito");
            })
            .catch(() => {
              openNotification("Error al actualizar la capa.");
            });
        };
        return (
          <Button
            size="small"
            disabled={isDefault || loading}
            onClick={handleClick}
          >
            Capa principal
          </Button>
        );
      }}
    </Mutation>
  );
};

export default compose(withNotification)(SelectAsDefaultButton);



// WEBPACK FOOTER //
// ./src/components/admin/carto/layers/select-as-default.js